var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('report-summary',{attrs:{"cells":_vm.cells}}),_c('report-performance-bands',{attrs:{"performanceBands":_vm.performanceBands}}),_c('report-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"initialSortedColumns":['lastName']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }